const VIPSonkoJobsIndex = () => import('./index.vue')
const VIPCreateJobPage = () => import('./_pages/create_job')
const VIPSonkoJobDetails = () => import('./_pages/details')
const VIPProjectDetails = () => import('./_pages/project')
const VIPEngagements = () => import('./_pages/engagements')
const VIPAssigned = () => import('./_pages/assigned')
import { CheckVIPSonkoGuard } from '@/common/guard'

export default [
    { 
        path: '/vip_sonko/jobs/:status',
        beforeEnter: CheckVIPSonkoGuard,
        component: VIPSonkoJobsIndex,
        name: 'VIPSonkoJobsIndex'
    },
    { 
        path: '/vip_sonko/job/details/:id',
        beforeEnter: CheckVIPSonkoGuard,
        component: VIPSonkoJobDetails,
        name: 'VIPSonkoJobDetails'
    },
    { 
        path: '/vip_sonko/project/details/:id',
        beforeEnter: CheckVIPSonkoGuard,
        component: VIPProjectDetails,
        name: 'VIPSonkoProjectDetails'
    },
    { 
        path: '/vip_sonko/job/engagements/:id',
        beforeEnter: CheckVIPSonkoGuard,
        component: VIPEngagements,
        name: 'VIPEngagements'
    },
    { 
        path: '/vip_sonko/job/assigned/:id',
        beforeEnter: CheckVIPSonkoGuard,
        component: VIPAssigned,
        name: 'VIPAssigned'
    },
    {
        path: '/vip_sonko/create/job',
        beforeEnter: CheckVIPSonkoGuard,
        component: VIPCreateJobPage,
        name: 'VIPCreateJobPage'
    }
]